import React from 'react';
import TopNavbar from '../userNavbar/TopNavbar';
import BottomNavbar from '../userNavbar/BottomNavbar';

const UserNavbar = () => {
    return (
        // <div className="sticky top-0 w-full z-50">
        <div className="w-full">
            <TopNavbar />
            <BottomNavbar />
        </div>
    );
};

export default UserNavbar;